<div class="container">
  <div class="container-day">
    <div>
      {{ 'FRONTEND.FORMS.SPECIAL_HOURS.DATE' | translate }}
    </div>
    <div>
      <div class="container-date-picker">
        <glxy-form-field>
          <mat-datepicker-toggle matPrefix [for]="picker" />
          <input
            (dateChange)="onDateChange($event.value)"
            [formControl]="selectedDate"
            matInput
            placeholder="Select a date"
            [matDatepicker]="picker"
          />
          <mat-datepicker #picker />
        </glxy-form-field>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="deleteDate()">
            <mat-icon>close</mat-icon>
            {{ 'FRONTEND.FORMS.SPECIAL_HOURS.REMOVE_DATE' | translate }}
          </button>
        </mat-menu>

        <button mat-icon-button color="primary" [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
    </div>
  </div>

  @if (_timePeriod) {
    <forms-day-of-week-edit
      [value]="_timePeriod"
      (hasAnyErrors)="handleHasAnyErrors($event)"
      (valueChange)="changeHours($event)"
    >
    </forms-day-of-week-edit>
  }
</div>
